import React from 'react';
import styles from './../styles/dashboard.module.scss'

const DashboardCanvas = ({children}) => {
  return (
    <section className={styles.__canvas}>
      <section className={styles.__content}>{children}</section>
    </section>
  )
}

export default DashboardCanvas;
